import { render, staticRenderFns } from "./whd.vue?vue&type=template&id=e3d8fa40&lang=pug&"
import script from "./whd.vue?vue&type=script&lang=js&"
export * from "./whd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports